<template>
  <div class="register-page">
    <status-bar />
    <div class="register-page-form">
      <div class="register-success">
        <div class="register-success__title">
          {{ $t('register-final-page.thanks-for-application') }}
        </div>
        <img src="@/assets/img/views/RegisterFinalPage/final-page.svg" alt="final-page" class="register-success__img" />
        <div class="register-success-text">
          <div>
            <p v-html="$t('register-final-page.application-was-sent')">
            </p>
          </div>
        </div>
      </div>
      <div class="register-page-form-actions">
        <router-link
          v-if="userInfo.is_resident"
          :to="{name: 'private-cabinet'}"
        >
          <pc-button variant="dark" class="w100">
            {{ $t('register-final-page.to-cabinet') }}
          </pc-button>
        </router-link>
        <a v-else :href="link" class="back-link">
          <pc-button variant="dark" class="w100">
            {{ $t('register-final-page.back-to-site') }}
          </pc-button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import StatusBar from '@/components/views/RegisterPage/StatusBar.vue'
import PcButton from '@/components/common/PcButton.vue'
import {api} from '@/api/api'
import {constants} from '@/constants'
import {mapGetters} from 'vuex'

export default {
  name: 'RegisterFinalPage',
  components: {
    PcButton,
    StatusBar
  },
  data() {
    return {
      alreadySent: false,
      link: process.env.VUE_APP_LANDING_REDIRECT_URL
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },

  async beforeMount() {
    this.alreadySent = this.$route.query.alreadySent === '1'
      try {
        await this.$store.dispatch('setUserInfo')

        if (this.userInfo.check_status === constants.CHECK_STATUSES.SIGNED) {
          await this.$router.push({name: 'private-cabinet'})
        }

      } catch(err) {
        this.currentStepNumber = this.getPageFromStorage()
        console.log(err)
      }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/views/register-common.scss";

.register-success {
  display: flex;
  flex-direction: column;

  &__title {
    margin-bottom: 50px;
    font-weight: 600;
    font-size: 20px;
    line-height: 23px;

    @media (max-width: #{$mobile}) {
      margin-bottom: 36px;
    }
  }

  &__img {
    align-self: center;
    margin-bottom: 50px;

    @media (max-width: #{$mobile}) {
      margin-bottom: 60px;
    }
  }

  &-text {
    display: grid;
    grid-row-gap: 1em;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
  }
}

.back-link {
  display: block;
}
</style>
